function CreatePubSub () {
  this.subscribers = {}

  this.subscribe = (eventType, callBackFunction) => {
    if (!this.subscribers[eventType]) {
      this.subscribers[eventType] = []
    }
    const index = this.subscribers[eventType].push(callBackFunction) - 1
    return {
      unsubscribe: () => {
        this.subscribers[eventType].splice(index, 1)
      }
    }
  }

  this.publish = (eventType, data) => {
    if (!this.subscribers[eventType]) return
    this.subscribers[eventType].forEach((subscriberCallBack) => {
      subscriberCallBack(data)
    })
  }
}

const pubSub = new CreatePubSub()

export default pubSub
